import {QueryClient, useQuery} from "react-query";
import {useEffect, useState} from "react";
import {AbstractPayloadEntity} from "@services/entities/baseEntity";
import {AxiosError} from "axios";
import {useRecoilState, useRecoilValue} from "recoil";
import {loadingState} from "@services/stores/storeState";

type QueryResult = {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    isRefetching: boolean;
    isFetching: boolean;
    isFetched: boolean;
    dataUpdatedAt: number;
}

const useLazyQuery = <T extends AbstractPayloadEntity<T['response']>>(
    key: string | any[],
    promise: (params: T, ...args: any[]) => Promise<T['response']>
): [(params?: T, ...args: any[]) => void, T['response'], QueryResult] => {
    const queryClient = new QueryClient();
    const [params, setParams] = useState<T | null>(null);
    const [doQuery, setDoQuery] = useState<boolean>(false);

    const [isLoading,setIsLoading] = useRecoilState(loadingState);

    const result = useQuery({
        queryKey: [key, params],
        queryFn: () => promise(params as T),
        enabled: doQuery,
        notifyOnChangeProps: 'tracked',
        onSuccess: (data) => {
            if (params?.callback) {
                params?.callback(data)
            }
        },
        onError: (err: AxiosError) => {
            const errorResponse: any = err?.response?.data;
            (err.response?.status) && (errorResponse.status = err.response?.status);
            (errorResponse && errorResponse.content) && (errorResponse.content = undefined);

            console.log(errorResponse)
            if (params?.callback) {
                params?.callback(errorResponse)
            }
        }
    });

    const executeQuery = (params?: T, index?: string) => {
        if (params) {
            setParams(params);
        }
        if (index) {
            key = [key, index];
        }
        setDoQuery(true);
    }

    useEffect(() => {
        if (result.isSuccess || result.isError) {
            setDoQuery(false);
        } else {
            queryClient.resetQueries([key, params])
            queryClient.invalidateQueries([key, params])
        }
    }, [result]);

    // useEffect(() => {
    //     if(result?.isLoading === true){
    //         const timer = setTimeout(() => setIsLoading(result?.isLoading === true), 1000);
    //         return () => clearTimeout(timer);
    //     }else{
    //         setIsLoading(false);
    //     }
    // }, [result?.isLoading]);

    return [executeQuery, result.data, result];
}

export default useLazyQuery;
